import breakpoints from '@/theme/constants/breakpoints';
import zIndex from '@/theme/constants/zIndex';
import styled from 'styled-components';

export const StyledNavigation = styled.nav`
  display: none;
  width: 100%;
  @media only screen and ${breakpoints.device.l} {
    display: block;
    position: sticky;
    top: 0;
    z-index: ${zIndex.fixed}; // Element has sticky positioning to fit in the document flow properly, but needs to act as a fixed element
  }
`;
